"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InnerBannerBox = void 0;
const react_1 = __importDefault(require("react"));
const image_1 = __importDefault(require("next/image"));
const class_variance_authority_1 = require("class-variance-authority");
const Row_1 = require("../Row");
const Container_1 = require("../Container");
const utils_1 = require("../utils"); // Assuming `cn` utility is in utils
// Define the innerBannerBoxStyles using cva
const innerBannerBoxStyles = (0, class_variance_authority_1.cva)("w-full lg:w-[62%] order-1 lg:order-0 p-8 px-12 py-8 flex gap-4 flex-col min-h-[240px] justify-center", {
    variants: {
        bgColor: {
            green: "bg-green-950",
            blue: "bg-blue-900",
            red: "bg-red-900",
        },
    },
    defaultVariants: {
        bgColor: "green",
    },
});
// The InnerBannerBox component with cn utility integrated for className handling
const InnerBannerBox = ({ children, imageUrl, altText, bgColor, imgClassName = "", contentClassName = "", priority }) => {
    return (react_1.default.createElement(Container_1.Container, null,
        react_1.default.createElement(Row_1.Row, { className: (0, utils_1.cn)("flex flex-col lg:flex-row gap-4") },
            react_1.default.createElement("div", { className: (0, utils_1.cn)("flex flex-col lg:flex-row w-full rounded-[12px] overflow-hidden mb-6") },
                react_1.default.createElement("div", { className: (0, utils_1.cn)(innerBannerBoxStyles({ bgColor }), contentClassName) }, children),
                react_1.default.createElement("div", { className: (0, utils_1.cn)("w-full lg:w-[38%] relative order-0 lg:order-1 min-h-[185px] md:min-h-[315px] lg:min-h-[240px]", imgClassName) },
                    react_1.default.createElement(image_1.default, { src: imageUrl, className: "object-cover", layout: "fill", loading: "eager", alt: altText, ...(priority && { priority: true, fetchPriority: "high" }) }))))));
};
exports.InnerBannerBox = InnerBannerBox;
